// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1T0ou","colBig":"styles_colBig__1SZ9P","colSmall":"styles_colSmall__1_kaD","shopifyNameWrapper":"styles_shopifyNameWrapper__2TiNe"};